import React from "react";
//import { PropTypes } from "prop-types";
import { FormSelectSimple } from "../../_atoms/_form-input-simple/FormSelectSimple";
import { Form } from "../../_molecules/_form/Form";
import { ListSelector } from "../../_molecules/_list-selector/ListSelector";
import "./_dealer-selector.scss";
export const DealerSelector = ({ children, name, onSubmit, onChange, onChangeSelect, onClick, dealers, provinceSelected, showButton, modalClick, title, subtitle }) => {
  //convertimos los dealers a array
  let dealersArray = Object.values(dealers);
  //Sacamos las provincias
  let provinces = dealersArray.map((item) => {
    return item.nombre_provincia;
  });
  //Eliminamos duplicados
  provinces = new Set(provinces);
  //Volvemos a pasar a Array
  provinces = [...provinces];

  return (
    <div className="dealer-selector">
      <span className="h3">{title}</span>

      <Form css="form--simple" onSubmit={onSubmit}>
        <fieldset>
          <legend className="h4">
            {subtitle}
            {/*
            <button
              className="dealer-selector__map-button"
              onClick={modalClick}
              type="button">
              <svg className="icon icon--xs" role="presentation">
                <use xlinkHref="./svg/sprite.svg#marker"></use>
              </svg>
              Vista en el mapa
            </button>
            */}
          </legend>
          <FormSelectSimple label="Elige la provincia" name="province" onChange={onChange}>
            {provinces.map((item, i) => {
              return (
                <option key={i} value={item}>
                  {item}
                </option>
              );
            })}
          </FormSelectSimple>
        </fieldset>
        {provinceSelected && (
          <fieldset>
            <legend className="h4">Selección del taller</legend>

            <FormSelectSimple label="Selección del taller" name="province" onChange={onChangeSelect}>
              {dealersArray.map((item) => {
                if (item.nombre_provincia === provinceSelected) {
                  return (
                    <option key={item.id_outlet} value={item.id_outlet}>
                      {item.nombre} {item.direccion}
                    </option>
                  );
                } else {
                  return <></>;
                }
              })}
            </FormSelectSimple>
            {/*
            <ul>
              {dealersArray.map((item) => {
                if (item.nombre_provincia === provinceSelected) {
                  return (
                    <li key={item.id_outlet}>
                      <ListSelector
                        id={item.id_outlet}
                        name={item.nombre}
                        address={item.direccion}
                        onClick={onClick}
                      />
                    </li>
                  );
                } else {
                  return <></>;
                }
              })}

              <li></li>
            </ul>*/}
          </fieldset>
        )}
      </Form>
    </div>
  );
};
